const React = require('react');

const {
  UI: { BUTTONS },
  COMMONS: { COLORS_BY_STATUS, CHECKOUT_CASE, DELAY },
} = require('../../../../../constants');

const FLOW = {
  NOTIFICATION: 'notification',
  PAYMENT_METHOD: 'payment_method',
};

const configRef = { current: {} };
const isFirstRenderRef = { current: true };

const useDiscountNotification = ({
  translations,
  notification,
  templateCase,
  paymentMethods,
  showNotification,
}) => {
  const handleUseEffectUnmount = () => {
    configRef.current = {};
    isFirstRenderRef.current = true;
  };

  const handleDiscountNotification = () => {
    if (document.querySelector(BUTTONS.DISCOUNT_CHEVRON_UP_CLASS)) {
      document.getElementById(BUTTONS.DISCOUNT_TRIGGER)?.click();
    }

    showNotification(
      configRef.current?.[FLOW.NOTIFICATION] ||
        configRef.current?.[FLOW.PAYMENT_METHOD],
    );
  };

  // General Review useEffect observes $.step_model.notification to show notification
  React.useEffect(() => {
    if (!notification || templateCase === CHECKOUT_CASE.EXPRESS) {
      return;
    }

    configRef.current = {
      ...configRef.current,
      [FLOW.NOTIFICATION]: {
        component: notification?.message,
        status: COLORS_BY_STATUS[notification?.status?.toUpperCase()],
        displayTimeout: DELAY.TEN_SECONDS,
      },
    };

    handleDiscountNotification();
  }, [notification]);

  // Review Express useEffect observes $.step_model.paymentMethods[].discount to show notification
  React.useEffect(() => {
    if (templateCase !== CHECKOUT_CASE.EXPRESS) {
      return;
    }

    const hasDiscount = !!paymentMethods?.find((pm) => pm.discount);

    configRef.current = {
      ...configRef.current,
      [FLOW.PAYMENT_METHOD]: {
        displayTimeout: DELAY.TEN_SECONDS,
        status: hasDiscount ? COLORS_BY_STATUS.SUCCESS : COLORS_BY_STATUS.ERROR,
        component: hasDiscount
          ? translations.SUCCESS_DISCOUNT_NOTIFICATION
          : translations.ERROR_DISCOUNT_NOTIFICATION,
      },
    };

    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      return;
    }

    handleDiscountNotification();
  }, [paymentMethods]);

  React.useEffect(() => () => handleUseEffectUnmount(), []);
};

module.exports = { useDiscountNotification };
